import type { Translations } from './pt-BR';

const ptPT: Translations = {
  nav: {
    dashboard:    'Início',
    forecast:     'Previsão',
    birthChart:   'Mapa Astral',
    synastry:     'Sinastria',
    questions:    'Pergunta aos Astros',
    astromatch:   'AstroMatch',
    tarot:        'Tarot de Marselha',
    lenormand:    'Tarot Cigano',
    numerology:   'Numerologia',
    iChing:       'I Ching',
    dreamJournal: 'Diário dos Sonhos',
    moonPhases:   'Fases da Lua',
    agenda:       'Agenda Astrológica',
    retrograde:   'Radar Retrógrado',
    eclipses:     'Eclipse Insight',
    astroPet:     'Astro Pet',
    astroCoach:   'Astro Coach',
    startAstral:  'Rota Profissional',
    empresas:     'Empresas',
    astrocartografia:    'Astrocartografia',
    wallet:         'Carteira',
    readings:       'Leituras',
    settings:       'Configurações',
    signOut:        'Sair',
    quiromancy:     'Quiromancia',
    vedicAstrology: 'Astrologia Védica',
    humanDesign:    'Design Humano',
    blog:           'Blog',
    pricing:        'Planos',
  },
  credits: {
    questions:  'Créditos de perguntas',
    synastry:   'Créditos de sinastria',
    astromatch: 'Créditos AstroMatch',
  },
  home: {
    heroBadge:       'Personalizado para ti. Não para o teu signo.',
    heroHeadline1:   'Segredo',
    heroHeadline2:   'Astral.',
    heroSubheadline: 'Astrologia, tarô, I Ching, numerologia e muito mais, revelados para ti especificamente.',
    heroCta1:        'Descobre o teu Segredo Astral →',
    heroCta2:        'Ver previsões do dia',
    heroSocialProof: '✦ Mais de 50.000 leituras realizadas',
    heroScrollHint:  'Ver previsões dos signos',

    signForecastTitle:    'Previsão do dia',
    signForecastSubtitle: 'Seleciona o teu signo e consulta o que os astros reservam para hoje.',
    forecastToday:        'Previsão de hoje',
    forecastWeek:         'Previsão desta semana',
    forecastMonth:        'Previsão deste mês',
    consultingStars:      'A consultar os astros para {sign}...',
    starsMoving:          'Os astros estão em movimento. Tenta novamente em instantes ✦',
    seeFullForecast:      'Ver previsão completa ✦',

    featureTitle:    'Tudo o que precisas, num só lugar',
    featureSubtitle: 'Da previsão diária ao mapa astral completo, a tradição de 3.000 anos ao alcance do teu dia.',
    startFree:       'Começar gratuitamente ✦',

    feat: {
      birthChartTitle:    'Mapa Astral',
      birthChartDesc:     'Descobre os teus planetas, casas e aspetos com interpretação completa em português.',
      birthChartBadge:    'Premium',
      forecastTitle:      'Previsão Personalizada',
      forecastDesc:       'Previsões diárias, semanais e mensais calculadas para o teu mapa natal.',
      synastryTitle:      'Sinastria',
      synastryDesc:       'Compara o teu mapa com o de alguém especial e vê a compatibilidade completa.',
      synastryBadge:      'Premium',
      questionsTitle:     'Pergunta aos Astros',
      questionsDesc:      'Faz qualquer pergunta e recebe uma resposta astrológica personalizada.',
      astromatchTitle:    'AstroMatch',
      astromatchDesc:     'Envia uma foto e descobre a personalidade astrológica através da fisiognomia.',
      astromatchBadge:    'Exclusivo',
      moreTitle:          'Tarot, I Ching e mais',
      moreDesc:           'Tiragem de Tarot, I Ching, Numerologia, Diário dos Sonhos e Fases da Lua.',
    },

    premiumBadge:   '✦ Plano Premium',
    premiumTitle1:  'Mergulha fundo',
    premiumTitle2:  'nos teus astros',
    premiumDesc:    'Com o Professya Premium tens acesso ao mapa astral completo, sinastria ilimitada, previsões personalizadas e muito mais, por menos de 1 € por dia.',
    premiumF1:      'Mapa astral completo com interpretação',
    premiumF2:      'Previsões diárias, semanais e mensais',
    premiumF3:      'Sinastria de relacionamentos',
    premiumF4:      'Perguntas ilimitadas aos astros',
    premiumF5:      'AstroMatch por foto',
    premiumF6:      'Acesso a Tarot, I Ching e Numerologia',
    premiumPrice:   '4,99 €',
    premiumPer:     '/mês',
    premiumCta:     'Subscrever agora ✦',
    premiumCancel:  'Cancela quando quiseres. Sem fidelização.',

    demoLabel1: 'Mapa Astral',
    demoSub1:   'Sol em Áries · Lua em Touro · ASC Gémeos',
    demoLabel2: 'Sinastria',
    demoSub2:   'Compatibilidade 87% ✦ Vénus em harmonia',
    demoLabel3: 'Previsão de hoje',
    demoSub3:   '"Vénus favorece ligações profundas..."',

    servicesTitle:    'Os Nossos Serviços',
    servicesSubtitle: 'Da previsão diária ao mapa natal completo, tudo para o teu autoconhecimento astrológico.',
    servicesCta:      'Aceder a todos os serviços ✦',
    badgePlan:        'Plano',
    badgeCredits:     'Créditos',
    badgeAvulso:      'Avulso',
    badgeNew:         'Novo ✦',
    svc: {
      birthChart:  { name: 'Mapa Astral',           subtitle: 'O teu mapa natal completo',                    description: 'Descobre a posição exata de todos os planetas, casas e aspetos no momento do teu nascimento. Não é um horóscopo genérico, é o mapa único que só tu possuis.' },
      forecast:    { name: 'Previsão Personalizada', subtitle: 'Diária, semanal, mensal e anual',              description: 'Previsões calculadas para o TEU mapa natal, não para o teu signo. Sabe exatamente quais planetas estão a ativar a tua vida agora e o que esperar nos próximos meses.' },
      synastry:    { name: 'Sinastria',              subtitle: 'Compatibilidade profunda entre dois mapas',    description: 'Analisa a ligação real entre dois mapas natais. Descobre os aspetos que criam atração, tensão, missão kármica e potencial de longo prazo em qualquer relação.' },
      astroMatch:  { name: 'AstroMatch',             subtitle: 'Compatibilidade antes do primeiro encontro',  description: 'Indica o nome, signo e algumas características de alguém e descobre o potencial astrológico dessa ligação antes de te envolveres. Poupa tempo e energia.' },
      astrocartografia: { name: 'Astrocartografia',           subtitle: 'Onde no mundo prosperas',                     description: 'Compara o teu mapa natal com o de 195 países e descobre onde tens mais potencial de amor, carreira, saúde e qualidade de vida. Também analisa qualquer cidade específica.' },
      questions:   { name: 'Pergunta aos Astros',    subtitle: 'Respostas diretas do oráculo',                description: 'Faz qualquer pergunta e recebe uma resposta personalizada com base nos trânsitos planetários ativos no teu mapa natal neste exato momento.' },
      tarot:       { name: 'Tarot de Marselha',       subtitle: '4 tipos de tiragem interpretados',            description: 'Tiragens de 1, 3, 7 e 10 cartas com interpretação profunda baseada na tradição do Tarot de Marselha, aliada à posição dos teus planetas no momento da consulta.' },
      lenormand:   { name: 'Tarot Cigano',         subtitle: 'Lenormand, O oráculo das 36 cartas',         description: 'O Tarot Cigano revela padrões ocultos da tua vida através das 36 cartas de Lenormand. Tiragens de 1, 3, 5 ou 9 cartas com interpretação personalizada e simbólica.' },
      numerology:  { name: 'Numerologia',            subtitle: 'Os números que regem a tua vida',             description: 'Número do Destino, Alma, Personalidade e Ano Pessoal calculados a partir do teu nome completo e data de nascimento. Descobre os ciclos que governam a tua jornada.' },
      astroPet:    { name: 'Astro Pet',              subtitle: 'O mapa natal do teu animal',                  description: 'Calcula o mapa natal do teu pet e descobre a sua personalidade astrológica. Analisa também a compatibilidade entre ti e o teu animal de estimação.' },
      startAstral: { name: 'Rota Profissional',           subtitle: 'A tua vocação pelo mapa natal',               description: 'Análise completa do teu Meio do Céu, Saturno, Júpiter e Nodo Norte para revelar a tua vocação, talentos naturais e o caminho profissional mais alinhado com quem és.' },
      retrograde:  { name: 'Radar Retrógrado',       subtitle: 'Impacto real no teu mapa',                    description: 'Sabe exatamente como Mercúrio, Vénus, Marte e outros planetas retrógrados afetam o TEU mapa natal, não uma previsão genérica por signo.' },
      eclipse:     { name: 'Eclipse Insight',        subtitle: 'Eclipses que ativam a tua vida',              description: 'Descobre quais casas e planetas do teu mapa natal são ativados pelos eclipses solares e lunares, e o que isso significa para os próximos 6 meses da tua vida.' },
    },
  },
  auth: {
    email:            'E-mail',
    password:         'Palavra-passe',
    confirmPassword:  'Confirmar palavra-passe',
    signIn:           'Entrar',
    createAccount:    'Criar conta',
    forgotPassword:   'Esqueci a minha palavra-passe',
    resetPassword:    'Redefinir palavra-passe',
    noAccount:        'Não tens conta?',
    hasAccount:       'Já tens conta?',
    orContinue:       'ou continua com',
    sendReset:        'Enviar link de redefinição',
    backToLogin:      'Voltar ao início de sessão',
    checkEmail:       'Verifica o teu e-mail para o link de redefinição.',
    signInTitle:      'Entra na tua conta',
    createTitle:      'Cria a tua conta gratuita',
    name:             'Nome',
    namePlaceholder:  'O teu nome',
    showPassword:     'Mostrar palavra-passe',
    hidePassword:     'Ocultar palavra-passe',
    createFree:       'Criar conta grátis',
    createCta:        'Criar conta ✦',
    agreeText:        'Ao criar conta concordas com os nossos',
    terms:            'Termos',
    privacyPolicy:    'Política de Privacidade',
    biometricTitle:   '✦ Queres entrar mais depressa?',
    biometricDesc:    'Ativa o Face ID / Touch ID para entrar no Professya sem digitar a palavra-passe.',
    biometricEnable:  'Ativar Face ID / Touch ID',
    biometricSkip:    'Agora não',
    continueGoogle:   'Continuar com Google',
    continueApple:    'Continuar com Apple',
    oauthError:       'Não foi possível autenticar. Tente novamente.',
  },
  common: {
    loading:      'A carregar...',
    error:        'Erro',
    retry:        'Tentar novamente',
    save:         'Guardar',
    cancel:       'Cancelar',
    back:         'Voltar',
    close:        'Fechar',
    confirm:      'Confirmar',
    language:     'Idioma',
  },
  dashboard: {
    cosmicBrief:       '✦ Breve Cósmico',
    consultingStars:   'A consultar os astros para ti...',
    starsMoving:       'Os astros estão em movimento. O teu breve cósmico estará pronto em instantes ✦',
    completeBanner:    '✦ Completa o teu perfil',
    completeBannerSub: 'Adiciona a tua data de nascimento para leituras personalizadas.',
    addData:           'Adicionar dados',
    quickAccess:       'Acesso rápido',
    continueJourney:   'Continua a tua jornada',
    seeAll:            'Ver todas',
    greetingMorning:   'Bom dia',
    greetingAfternoon: 'Boa tarde',
    greetingEvening:   'Boa noite',
    errorTitle:        'Algo correu mal',
    errorSubtitle:     'Não conseguimos carregar o teu perfil. Tenta atualizar a página.',
    reload:            'Atualizar',
    suggBirthChartDesc: 'Descobre os teus planetas e casas astrológicas.',
    suggForecastTitle:  'Previsão da semana',
    suggForecastDesc:   'O que os astros reservam para ti esta semana.',
    suggQuestionsDesc:  'Faz a tua primeira pergunta com 1 crédito gratuito.',
    premiumBadge:        'Premium ativo ✦',
    premiumWelcomeTitle: 'Bem-vindo ao Professya Premium!',
    premiumWelcomeDesc:  'Explora os teus primeiros recursos.',
    premiumClose:        'Fechar',
    premiumStep1:        'Mapa Natal',
    premiumStep2:        'Previsão',
    premiumStep3:        'Sinastria',
    premiumStep4:        'AstroMatch',
    premiumStep5:        'Tarô',
    renewalTitle:        'A tua subscrição expira {when}',
    renewalToday:        'hoje',
    renewalTomorrow:     'amanhã',
    renewalDays:         'em {days} dias',
    renewalDesc:         'Renova agora para não perderes o acesso Premium.',
    renewalCta:          'Renovar ✦',
    tierPremium:         'Premium',
    streakSingular:      'dia consecutivo',
    streakPlural:        'dias consecutivos',
    creditQuestionsSingular: 'pergunta',
    creditQuestionsPlural:   'perguntas',
    creditSynastry:          'sinastria',
  },
  layout: {
    navSigns:      'Signos',
    navBlog:       'Blog',
    navPlans:      'Planos',
    navMyAccount:  'A Minha Conta',
    navSignIn:     'Entrar',
    navStartFree:  'Começar grátis',
    footerTagline: 'Astrologia e esoterismo para o teu dia a dia.',
    footerProduct: 'Produto',
    footerLegal:   'Legal',
    footerRights:  'Todos os direitos reservados.',
    footerMotto:   'Segredo Astral',
    footerSignos:  'Signos',
    footerBirthChart: 'Mapa Astral',
    footerSynastry:   'Sinastria',
    footerQuestions:  'Perguntas',
    footerPrivacy:    'Privacidade',
    footerTerms:      'Termos de utilização',
    footerLgpd:       'Proteção de dados',
    footerBrandTagline:  'Professya, O teu autoconhecimento revelado pelos astros, tarô, I Ching e muito mais.',
    footerServices:      'Serviços',
    footerOracles:       'Oráculos',
    footerForecast:      'Previsão',
    footerAstroMatch:    'AstroMatch',
    footerAstrocartografia:   'Astrocartografia',
    footerStartAstral:   'Rota Profissional',
    footerTarot:         'Tarô',
    footerIChing:        'I Ching',
    footerNumerology:    'Numerologia',
    footerAstroPet:      'Astro Pet',
    footerPrivacyFull:   'Política de Privacidade',
    footerTermsFull:     'Termos de Utilização',
    footerLgpdFull:      'Proteção de Dados',
    footerCancellation:  'Cancelamento',
    footerBusiness:      'Para Empresas',
    footerContact:       'Contacto',
    footerCopyright:     '© {year} Professya. Todos os direitos reservados.',
    footerDisclaimer:    'As leituras têm carácter reflexivo e de entretenimento. ✦',
    footerNewsletterDesc: 'Novidades astrológicas no teu email. Sem spam.',
  },
  forecast: {
    title:          'Previsão',
    emptyTitle:     'Data de nascimento necessária',
    emptySubtitle:  'Adiciona a tua data de nascimento para receber previsões personalizadas.',
    emptyCta:       'Adicionar dados',
    starsMoving:    'Os astros estão em movimento. Tenta novamente em instantes ✦',
    periodToday:    'Hoje',
    periodWeek:     'Esta Semana',
    periodMonth:    'Este Mês',
    periodYear:     'Este Ano',
    loadingDaily:   'A consultar os astros de hoje...',
    loadingWeekly:  'A calcular a semana astrológica...',
    loadingMonthly: 'A analisar o mês nos astros...',
    loadingAnnual:  'A preparar a tua previsão anual...',
    skyNow:              'Céu Agora',
    transitShort:        'Hoje & Esta Semana',
    transitMedium:       'Em Vigor Há Mais de 30 Dias',
    transitMediumBadge:  'Médio prazo',
    transitLong:         'Transformações de Fundo',
    transitLongBadge:    'Longo prazo',
    transitApproaching:  '↗ A entrar',
    transitPeak:         '◉ No pico',
    transitSeparating:   '↘ A sair',
    transitLongTermChip: '⟳ Longo prazo',
    transitRetrograde:   '® Retrógrado',
    illumination:        'iluminação',
    regenerateTitle:     'Gerar nova previsão',
    regenerateCta:       '↺ Regenerar',
    stillThinking:       'Os astros ainda estão revelando... ✦',
  },
  tabs: {
    home:      'Início',
    forecast:  'Previsão',
    questions: 'Perguntar',
    match:     'Match',
    wallet:    'Carteira',
    ariaLabel: 'Navegação principal',
    map:       'Mapa',
    atlas:     'Local',
    profile:   'Perfil',
    search:    'Procurar',
    today:     'Hoje',
    me:        'Eu',
  },
  pages: {
    onboarding: {
      stepOf: 'Passo {step} de {total}',
      welcomeTitle: 'Olá, {name}!',
      welcomeText: 'Bem-vindo ao Professya, o teu espaço de astrologia e esoterismo.\nVamos preparar a tua experiência personalizada em poucos passos.',
      welcomeCta: 'Começar ✦',
      birthDataTitle: 'Os teus dados de nascimento',
      birthDataDesc: 'Necessários para calcular o teu mapa astral. O horário é opcional, mas melhora a precisão.',
      birthDateLabel: 'Data de nascimento',
      birthTimeLabel: 'Hora de nascimento',
      birthCityLabel: 'Cidade de nascimento',
      optional: '(opcional)',
      youAreSign: 'És {sign}!',
      backBtn: 'Voltar',
      continueBtn: 'Continuar',
      skipNow: 'Saltar por agora',
      skipSetup: 'Saltar configuração →',
      firstReadingTitle: 'A tua primeira leitura',
      firstReadingDesc: 'Como {sign}, os astros já têm muito para te dizer.',
      firstReadingDesc2: 'Com os teus dados completos, os astros podem falar diretamente contigo.',
      previewLabel: 'Pré-visualização do teu painel:',
      previewFeat1Label: 'Previsão de hoje',
      previewFeat1Desc: 'Calculada para o teu mapa natal',
      previewFeat2Label: 'Mapa Astral',
      previewFeat2Desc: 'Sol, Lua, Ascendente e mais 8 planetas',
      previewFeat3Label: 'Pergunta aos Astros',
      previewFeat3Desc: '1 pergunta gratuita na conta nova',
      viewDashboard: 'Ver o meu painel',
      upgradeTitle: 'Aprofunda a tua jornada',
      upgradeDesc: 'Com o Premium tens acesso ao mapa astral completo, sinastria, previsões personalizadas e muito mais, por menos de 1€ por dia.',
      upgradeF1: 'Mapa astral completo',
      upgradeF2: 'Sinastria de relacionamentos',
      upgradeF3: 'Previsões diárias personalizadas',
      upgradeF4: 'Perguntas ilimitadas aos astros',
      upgradeF5: 'AstroMatch por foto',
      upgradeCta: 'Subscrever Premium ✦',
      upgradeFreeCta: 'Continuar com a conta gratuita →',
    },
    birthChart: {
      title: 'Mapa Astral',
      houseSystem: 'Cálculo Preciso',
      howToRead: 'Como ler o meu mapa',
      calculating: 'A calcular os teus planetas e casas astrológicas...',
      planetPositions: 'Posições Planetárias',
      planet: 'Planeta', sign: 'Signo', degree: 'Grau', house: 'Casa',
      showAll: 'Ver todos os planetas ({n} mais)',
      showLess: 'Mostrar menos',
      interpretation: 'Interpretação ✦',
      calculateCta: 'Calcular o meu mapa astral',
      retry: '↺ Tentar novamente',
      starsMoving: 'Os astros estão em movimento intenso agora. Tenta novamente em instantes ✦',
      emptyTitle: 'Dados de nascimento necessários',
      emptySubtitle: 'Para calcular o teu mapa astral, precisamos da tua data de nascimento. Adiciona em Perfil.',
      emptyCta: 'Ir para Perfil',
      guideTitle: 'Como ler o teu mapa',
      guideCta: 'Entendido ✦',
    },
    synastry: {
      title: 'Compatibilidade Astrológica',
      subtitle: 'Sinastria',
      partnerDataTitle: 'Dados do(a) parceiro(a)',
      partnerNameLabel: 'Nome',
      partnerNamePlaceholder: 'Nome da pessoa',
      partnerSignLabel: 'Signo solar',
      selectSign: 'Seleciona o signo',
      partnerDateLabel: 'Data de nascimento',
      autoAnalyzeHint: 'A análise inicia automaticamente ao preencher este campo',
      analyzeCta: 'Analisar compatibilidade (1 crédito)',
      inviteText: 'Preferes que a outra pessoa preencha os dados dela?',
      generateLink: 'Gerar link de convite via WhatsApp',
      linkGenerated: 'Link gerado:',
      copyBtn: 'Copiar',
      compatibility: 'Compatibilidade',
      noCreditsMsg: 'Não tens créditos de sinastria.',
      buyLink: 'Comprar →',
      calculating: 'A calcular a sinastria entre {partner} e {user}...',
      newAnalysis: 'Nova sinastria',
      errorMsg: 'Análise de sinastria temporariamente indisponível. Tenta novamente ✦',
      emptyTitle: 'Dados de nascimento necessários',
      emptySubtitle: 'Adiciona a tua data de nascimento para fazer sinastria.',
      emptyCta: 'Ir para Perfil',
      tabScore: 'Score', tabAnalise: 'Análise', tabAspectos: 'Aspectos',
      tabCasas: 'Casas', tabComposto: 'Composto', tabDavison: 'Davison',
      tabTransitos: 'Trânsitos', tabProgressoes: 'Progressões',
      scoreLove: 'Amor e Química', scoreCommunication: 'Comunicação', scoreValues: 'Valores',
      scoreLongTerm: 'Longo Prazo', scoreGrowth: 'Crescimento', scoreRoutine: 'Rotina', scoreFamily: 'Família',
    },
    tarot: {
      title: 'Tarot de Marselha',
      subtitle: 'Tradição clássica dos Arcanos Maiores e Menores',
      restart: 'Recomeçar',
      intentionMsg: 'Concentra-te numa pergunta...',
      loading: 'Os arcanos estão a organizar-se...',
      generalReading: '✦ Leitura Geral',
      reversed: 'Invertida',
      spreadSingle: 'Carta do Dia',
      spreadSingleDesc: '1 carta, foco e energia do momento',
      spreadThree: 'Passado · Presente · Futuro',
      spreadThreeDesc: '3 cartas, linha do tempo',
      spreadHorseshoe: 'Ferradura',
      spreadHorseshoeDesc: '7 cartas, visão ampla da situação',
      spreadCeltic: 'Cruz Celta',
      spreadCelticDesc: '10 cartas, análise profunda',
    },
    lenormand: {
      title: 'Tarot Cigano',
      subtitle: 'Lenormand, O oráculo das 36 cartas',
      restart: 'Nova leitura',
      intentionMsg: 'Respira fundo e concentra-te na tua consulta...',
      loading: 'As cartas ciganas estão a revelar-se...',
      readingTitle: '✦ A tua Leitura',
      subscriptionRequired: 'Esta consulta está disponível para assinantes mensais ou anuais.',
      spreadSingle: 'Carta do Momento',
      spreadSingleDesc: '1 carta, a mensagem essencial',
      spreadThree: 'Linha do Tempo',
      spreadThreeDesc: '3 cartas, passado, presente e caminho',
      spreadFive: 'Cruz',
      spreadFiveDesc: '5 cartas, situação e conselho',
      spreadNine: 'Quadrado',
      spreadNineDesc: '9 cartas, leitura completa',
      questionLabel: 'A tua consulta (opcional)',
      questionPlaceholder: 'O que desejas compreender? Deixa em branco para uma leitura geral.',
      questionCta: 'Revelar as cartas ✦',
    },
    questions: {
      title: 'Pergunta aos Astros',
      questionLabel: 'A tua pergunta',
      questionPlaceholder: 'Escreve a tua pergunta para os astros...',
      showExamples: 'Ver exemplos de perguntas',
      hideExamples: 'Ocultar exemplos',
      disclaimer: 'Respostas de carácter reflexivo · Consulta profissionais para decisões importantes',
      submitCta: 'Perguntar (1 crédito)',
      submitLoading: 'A consultar os astros...',
      answerTitle: '✦ Os astros respondem',
      historyTitle: 'Histórico de perguntas',
      noCreditsTitle: 'Não tens créditos suficientes. Queres reabastecer?',
      noCreditsDesc: 'Os teus créditos acabaram. Escolhe um pacote abaixo para continuar.',
      loading: 'Os astros estão a considerar a tua pergunta...',
      emptyTitle: 'Completa o teu perfil primeiro',
      emptySubtitle: 'Adiciona a tua data de nascimento para fazer perguntas personalizadas aos astros.',
      emptyCta: 'Ir para Perfil',
    },
    numerology: {
      title: 'Numerologia',
      subtitle: 'Os números que regem a tua jornada',
      intro: 'Calcula o teu mapa numerológico completo baseado no teu nome e data de nascimento.',
      calculateCta: 'Calcular a minha numerologia ✦',
      calculating: 'Os números estão a ser calculados...',
      lifePathLabel: 'Caminho de Vida',
      destinyLabel: 'Destino',
      soulLabel: 'Alma',
      personalityLabel: 'Personalidade',
      newConsult: 'Nova consulta',
      error: 'Os números estão em alinhamento. Tenta novamente em instantes ✦',
      emptyTitle: 'Dados necessários',
      emptySubtitle: 'Adiciona o teu nome e data de nascimento no perfil para calcular a tua numerologia.',
      emptyCta: 'Ir para Perfil',
      tabSinteseGeral: 'Síntese Geral', tabCaminhoDeVida: 'Caminho de Vida',
      tabDestino: 'Número do Destino', tabAlma: 'Número da Alma', tabPersonalidade: 'Personalidade',
    },
    iching: {
      title: 'I Ching',
      subtitle: 'O Livro das Mutações',
      intro: 'O I Ching consulta os padrões de mutação do universo para revelar a essência da tua situação.',
      questionLabel: 'A tua pergunta',
      questionPlaceholder: 'O que desejas compreender?',
      throwingCoins: 'A lançar as moedas...',
      consultCta: 'Consultar o oráculo ✦',
      throwingMsg: 'A lançar as moedas sagradas...',
      interpretingMsg: 'O oráculo está a interpretar as mutações...',
      hexagramLabel: 'Hexagrama {n}, {name}',
      transformsInto: 'Transforma-se em: Hexagrama {n}',
      newConsult: 'Nova consulta',
      error: 'O oráculo está em silêncio. Tenta novamente em instantes ✦',
    },
    dreamJournal: {
      title: 'Diário dos Sonhos',
      subtitle: 'Desvenda as mensagens do inconsciente',
      dreamLabel: 'Descreve o teu sonho',
      dreamPlaceholder: 'Descreve com detalhes o que sonhaste... Pessoas, lugares, sensações, cores...',
      interpretCta: 'Interpretar o meu sonho ✦',
      loading: 'A mergulhar nas camadas do inconsciente...',
      symbolsTitle: '✦ Símbolos identificados',
      interpretationTitle: '✦ Interpretação',
      guidanceTitle: '✦ Orientação',
      historyTitle: 'Diário',
      newEntry: 'Registar outro sonho',
      error: 'O inconsciente está em silêncio. Tenta novamente em instantes ✦',
    },
    moonPhases: {
      title: 'Fases da Lua',
      subtitle: 'Calendário lunar e energias do ciclo',
      illuminated: '{n}% iluminada',
      upcomingPhases: '✦ Próximas fases',
      ritualsFor: '✦ Rituais para {phase}',
    },
    humanDesign: {
      title: 'Design Humano',
      subtitle: 'O teu tipo e estratégia de vida',
      intro: 'Descobre o teu tipo de Design Humano, estratégia de vida e autoridade interna para tomar decisões com clareza.',
      calculateCta: 'Calcular o meu Design Humano ✦',
      calculating: 'A calcular o teu Design Humano...',
      birthTimeWarning: '✦ Hora de nascimento recomendada',
      birthTimeWarningDesc: 'O Design Humano é mais preciso com a tua hora de nascimento. Sem ela, usaremos um cálculo aproximado.',
      addBirthTime: 'Adicionar hora de nascimento →',
      profileLabel: 'Perfil',
      authorityLabel: 'Autoridade',
      strategyLabel: 'Estratégia',
      signatureLabel: 'Assinatura',
      notSelfLabel: 'Não-Self',
      centersTitle: '✦ Centros',
      recalculate: 'Recalcular',
      error: 'O sistema de Design Humano está em análise. Tenta novamente em instantes ✦',
      emptyTitle: 'Data de nascimento necessária',
      emptySubtitle: 'Adiciona a tua data de nascimento para calcular o teu Design Humano.',
      emptyCta: 'Ir para Perfil',
    },
    vedicAstrology: {
      title: 'Astrologia Védica',
      subtitle: 'Jyotish, a Ciência da Luz',
      intro: 'A astrologia védica (Jyotish) é um sistema milenar da Índia que usa o zodíaco sideral, revelando camadas profundas do destino, karma e propósito.',
      consultCta: 'Consultar Jyotish ✦',
      loading: 'A calcular o mapa védico...',
      addBirthTime: '✦ Adicionar a tua hora de nascimento torna a leitura muito mais precisa.',
      keyPositions: '✦ Posições chave',
      ascLabel: 'Ascendente (Lagna)',
      moonLabel: 'Signo da Lua',
      sunLabel: 'Signo do Sol',
      nakshatraLabel: 'Nakshatra',
      dashaLabel: 'Dasha atual',
      yogasLabel: 'Yogas presentes',
      newConsult: 'Nova consulta',
      error: 'Os astros védicos estão em alinhamento. Tenta novamente em instantes ✦',
      emptyTitle: 'Data de nascimento necessária',
      emptySubtitle: 'Adiciona a tua data de nascimento para aceder à astrologia védica.',
      emptyCta: 'Ir para Perfil',
    },
    astromatch: {
      title: 'AstroMatch',
      subtitle: 'Análise astrológica por fisiognomia',
      subjectNameLabel: 'Nome da pessoa',
      subjectNameOptional: '(opcional)',
      subjectNamePlaceholder: 'Ex: João',
      cameraBtn: 'Câmara / Galeria',
      noConsent: '↑ Aceita os termos acima para habilitar o envio de foto',
      newAnalysis: 'Nova análise',
      errorMsg: 'Não foi possível processar a análise. Tenta novamente ✦',
      errorRetry: 'Tentar com outra foto',
      loading1: 'A analisar traços faciais...',
      loading2: 'A consultar os astros...',
      loading3: 'A calcular a carta natal...',
      loading4: 'A preparar a tua análise ✦',
    },
    quiromancy: {
      title: 'Quiromancia',
      subtitle: 'A leitura das linhas da mão',
      handSelectorLabel: 'Qual mão desejas analisar?',
      rightHand: 'Mão Direita',
      leftHand: 'Mão Esquerda',
      rightHandHint: 'Mão direita, destino e presente',
      leftHandHint: 'Mão esquerda, potencial nato',
      instructions: 'Fotografa a palma da mão aberta com boa iluminação e fundo claro.',
      handTypeLabel: '✦ Tipo de mão',
      cameraBtn: 'Câmara / Galeria',
      noConsent: '↑ Aceita os termos acima para habilitar o envio de foto',
      newAnalysis: 'Nova análise',
      errorMsg: 'Não conseguimos ler as linhas desta imagem. Certifica-te de que a palma está bem visível e iluminada.',
      errorRetry: 'Tentar com outra foto',
      loading1: 'A analisar as linhas da mão...',
      loading2: 'A identificar os montes...',
      loading3: 'A consultar os astros...',
      loading4: 'A preparar a tua leitura ✦',
    },
    startAstral: {
      tabTalentos: 'Talentos', tabDesafios: 'Desafios', tabAmbientes: 'Ambientes',
      tabLideranca: 'Liderança', tabAreas: 'Áreas Profissionais', tabCaminhos: 'Caminhos Desafiantes', tabCiclos: 'Ciclos',
      tabVocacional: 'Mapa Vocacional', tabAtual: 'Carreira Atual', tabAlmejada: 'Cargo Almejado', tabTransicao: 'Transição',
    },
    readings: {
      title: 'Leituras',
      subtitle: 'O teu histórico de consultas',
      emptyAll: 'Nenhuma leitura encontrada ainda.',
      emptyFilter: 'Nenhuma leitura deste tipo ainda.',
      reading: 'Leitura',
    },
    notFound: {
      title: 'Página não encontrada',
      body:  'Os astros não conseguiram localizar esta página. Talvez ela se tenha perdido no cosmos.',
      back:  'Voltar ao início',
    },
    servicos: {
      heroCtaStart:          'Começar agora',
      heroCtaAccess:         'Aceder',
      heroBadgeFree:         'Disponível em todos os planos',
      heroBadgeMonthly:      'Disponível a partir do Plano Mensal',
      heroBadgeAnnual:       'Exclusivo do Plano Anual',
      tierFree:              'Gratuito',
      tierMonthly:           'Mensal',
      tierAnnual:            'Anual',
      benefitsTitle:         'O que vai descobrir',
      forWhoTitle:           'Este serviço é para si se...',
      previewTitle:          'Uma amostra do que vai receber',
      previewSubtitle:       'Exemplo ilustrativo, a sua análise é sempre única',
      previewUnlock:         '✦ Desbloqueie a sua análise completa',
      plansTitle:            'Escolha o seu plano e comece agora',
      plansRecommended:      '✦ RECOMENDADO PARA ESTE SERVIÇO',
      testimonialsTitle:     'O que as nossas utilizadoras dizem',
      faqTitle:              'Perguntas frequentes',
      finalCtaTitle:         'Comece agora e receba a sua análise em instantes',
      finalCtaAnonDesc:      'Demora menos de um minuto para criar a sua conta e explorar o universo Professya.',
      finalCtaCreateAccount: 'Criar conta gratuita',
      finalCtaHaveAccount:   'Já tenho conta',
      comingSoonBtn:         'Em breve ✦',
      comingSoonBadge:       'Lançamento em breve',
      comingSoonDesc:        'Estamos a dar os últimos retoques. Em breve poderá aceder a este serviço na Professya.',
    },
    profile: {
      title:    'A Minha Conta',
      subtitle: 'Gere as tuas informações e segurança.',
      planSection:  'O Meu Plano',
      currentPlan:  'Plano atual:',
      planFree:     'Gratuito',
      planMonthly:  'Mensal',
      planAnnual:   'Anual',
      planFreeFull:    'Gratuito',
      planMonthlyFull: 'Professya Mensal',
      planAnnualFull:  'Professya Anual',
      cancelCta:    'Cancelar subscrição',
      cancelPrompt: 'Vamos ter saudades. Se quiseres contar-nos o motivo (opcional):',
      cancelReasonPricey:        'Ficou caro',
      cancelReasonUnused:        'Não uso tanto quanto esperava',
      cancelReasonPause:         'Vou fazer uma pausa e voltarei',
      cancelReasonOtherPlatform: 'Encontrei outra plataforma',
      cancelReasonMisc:          'Outro motivo',
      cancelConfirmCta: 'Cancelar a minha subscrição',
      cancelling:       'A cancelar...',
      cancelError:      'Não foi possível cancelar. Tenta novamente ou entra em contacto.',
      cancelBack:       'Voltar',
      accountSection:   'Informações da conta',
      nameLabel:        'Nome:',
      emailLabel:       'Email:',
      planLabel:        'Plano:',
      birthSection:     'Dados de nascimento',
      birthEditBtn:     'Editar',
      birthDateLabel:   'Data:',
      birthTimeLabel:   'Hora:',
      birthCityLabel:   'Cidade:',
      birthTimeNotSet:  'Não indicada',
      birthSaveSuccess: 'Dados atualizados. A recalcular o teu mapa natal...',
      birthDateFormLabel: 'Data de nascimento',
      birthTimeFormLabel: 'Hora de nascimento (opcional)',
      birthCityFormLabel: 'Cidade de nascimento',
      birthCityPlaceholder: 'Ex: Lisboa',
      saveCta:      'Guardar',
      savingCta:    'A guardar...',
      cancelEditCta: 'Cancelar',
      confirmTitle: 'Recalcular mapa natal?',
      confirmDesc:  'Alterar a tua data de nascimento irá recalcular o teu mapa natal. As leituras anteriores não serão afetadas, mas as novas usarão os dados atualizados.',
      confirmCta:   'Confirmar e recalcular',
      securitySection: 'Segurança',
      genderLabel: 'Género:', genderM: 'Masculino', genderF: 'Feminino', genderNB: 'Não-binário', genderNotSay: 'Prefiro não dizer',
      birthLimitError: 'Atingiu o limite de 2 alterações de dados de nascimento. Contacte o suporte para solicitar uma correção.',
    },
  },
  shared: {
    privacyTitle: 'A tua privacidade é prioridade',
    privacyDesc: 'A foto é processada apenas para análise e nunca é guardada nos nossos servidores. Os dados de geolocalização (EXIF) são removidos antes do envio.',
    privacyConsent: '✓ Entendido, a foto não será guardada. Aceito prosseguir.',
    feedbackQuestion: 'Esta leitura foi útil?',
    feedbackThanks: 'Obrigado pelo teu feedback!',
    shareWhatsApp: 'Partilhar a minha Professya ✦',
    shareCopied: 'Texto copiado! Cola no WhatsApp ✦',
    shareError: 'Não foi possível partilhar. Tenta copiar o texto manualmente.',
    buyCredits: 'Comprar créditos ✦',
    newConsult: 'Nova consulta',
    retry: 'Tentar novamente',
  },
};

export default ptPT;
